import {
    CustomAlarmDefinitionAPI,
    NotificationTriggerAPI,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/service/custom-alarm-definition.api';
import {
    CustomAlarmDefinition,
    NotificationTrigger,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/domain/custom-alarm-definition.vm';

const mapNotificationTrigger = (notification: NotificationTriggerAPI): NotificationTrigger => ({
    enabled: notification.enabled,
    numberOfEvents: notification.numberOfEvents ?? undefined,
});

export const mapCustomAlarmDefinitionFromApi = (alarm: CustomAlarmDefinitionAPI): CustomAlarmDefinition => ({
    ...alarm,
    grayNotification: mapNotificationTrigger(alarm.grayNotification),
    yellowNotification: mapNotificationTrigger(alarm.yellowNotification),
    redNotification: mapNotificationTrigger(alarm.redNotification),
});
